module.exports = new __parcel__URL__("faq_expanded_en.8d575263.webp").toString();